import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/site";

export const CallButton = ({ className = "", label = "Call Now", testid = "call-cta-button" }) => (
  <a
    href={CONTACT.phoneTel}
    data-testid={testid}
    className={`group inline-flex items-center gap-2 rounded-full bg-brand-blue px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-brand-bluehover hover:shadow-[0_10px_30px_-8px_rgba(2,125,199,0.6)] active:scale-95 ${className}`}
  >
    <Phone className="h-4 w-4 transition-transform duration-300 group-hover:-rotate-12" />
    {label}
  </a>
);

export const WhatsAppButton = ({ className = "", label = "WhatsApp", testid = "whatsapp-cta-button" }) => (
  <a
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className={`group inline-flex items-center gap-2 rounded-full bg-brand-green px-6 py-3 text-sm font-semibold text-brand-accent transition-all duration-300 hover:bg-brand-greenhover hover:shadow-[0_10px_30px_-8px_rgba(126,218,88,0.7)] active:scale-95 ${className}`}
  >
    <MessageCircle className="h-4 w-4 transition-transform duration-300 group-hover:scale-110" />
    {label}
  </a>
);

export const CtaPair = ({ className = "" }) => (
  <div className={`flex flex-wrap items-center gap-3 ${className}`}>
    <CallButton label="Book Appointment" testid="book-appointment-button" />
    <WhatsAppButton />
  </div>
);
